import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import {
  Container,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import { db,auth } from "../api/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function YaeNoInoriEditor() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = async () => {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          const userData = userDoc.data();
          if (!userData?.isAdmin) {
            navigate("/home");
          } else {
            fetchItems(); // 管理者のみデータ取得
          }
        } else {
          navigate("/home");
        }
      });
    };

    checkAdmin();
  }, [navigate]);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    const snap = await getDocs(collection(db, "yaeNoInori"));
    const docs = snap.docs.map((d) => {
      const data = d.data();
      const openDate = data.openDate?.toDate?.()
        ? data.openDate.toDate()
        : new Date(data.openDate);
      return {
        id: d.id,
        ...data,
        openDate: openDate.toISOString().slice(0, 10), // YYYY-MM-DD形式
      };
    });

    // no 昇順で並び替え
    docs.sort((a, b) => (a.no || 0) - (b.no || 0));

    setItems(docs);
  };

  const handleOpenDateChange = async (id, newDate) => {
    const updatedItems = items.map((item) =>
      item.id === id ? { ...item, openDate: newDate } : item
    );
    setItems(updatedItems);

    try {
      await updateDoc(doc(db, "yaeNoInori", id), {
        openDate: new Date(newDate),
      });
    } catch (err) {
      console.error("openDate更新エラー:", err);
    }
  };

  const isPastOrToday = (dateStr) => {
    const today = new Date();
    const target = new Date(dateStr);
    today.setHours(0, 0, 0, 0); // 時間をゼロにして日付だけ比較
    target.setHours(0, 0, 0, 0);
    return target <= today;
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 3, overflowX: "auto" }}>
        <Typography variant="h6" gutterBottom>
          🙏 「八重の祈り」編集（開放日のみ編集可）
        </Typography>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>ステップ</TableCell>
              <TableCell>ステップ内容</TableCell>
              <TableCell>チャレンジ</TableCell>
              <TableCell>得られるもの</TableCell>
              <TableCell>開放日</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => {
              const isActive = isPastOrToday(item.openDate);
              return (
                <TableRow
                  key={item.id}
                  sx={{
                    backgroundColor: isActive ? "rgba(200,255,200,0.4)" : "inherit",
                  }}
                >
                  <TableCell>{item.no ?? "-"}</TableCell>
                  <TableCell>{item.step}</TableCell>
                  <TableCell>{item.stepContent}</TableCell>
                  <TableCell>{item.challenge}</TableCell>
                  <TableCell>{item.gain}</TableCell>
                  <TableCell>
                    <TextField
                      type="date"
                      size="small"
                      value={item.openDate}
                      onChange={(e) =>
                        handleOpenDateChange(item.id, e.target.value)
                      }
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}
